module.exports = __webpack_public_path__ + "media/images/emblems/Bregaglia_(Kreis)_wappen-2fff7020c68c884d174ee2125d0815c5.svg";